import { useQueryClient } from "@tanstack/react-query";
import { useQueryParam, NumberParam } from "use-query-params";
import { PAGE_LIMIT } from "@/config/constants";

export const useQueryCacheHelpers = () => {
  const queryClient = useQueryClient();
  const [page, setPage] = useQueryParam("page", NumberParam);
  return {
    updateItemProperty: (queryKey, itemId, updates) => {
      queryClient.setQueriesData({ queryKey }, (query) => {
        // Handle list queries with items array
        if (query?.items) {
          const itemIndex = query.items.findIndex((item) => item.id === itemId);
          if (itemIndex === -1) return query;
          const newItemsArray = [...query.items];
          newItemsArray[itemIndex] = {
            ...newItemsArray[itemIndex],
            ...updates
          };
          return { ...query, items: newItemsArray };
        }
        // Handle single item queries (detail view)
        if (query?.id === itemId) {
          return { ...query, ...updates };
        }
        return query;
      });
    },
    removeItem: (queryKey, itemId) => {
      queryClient.setQueriesData({ queryKey }, (query) => {
        if (!query?.items) return query;
        const itemIndex = query.items.findIndex((item) => item.id === itemId);
        if (itemIndex === -1) return query;
        const newItemsArray = [...query.items];
        newItemsArray.splice(itemIndex, 1);
        if (page > 1 && (query?.totalItems - 1) % PAGE_LIMIT === 0) {
          // works only for tables which use default PAGE_LIMIT and not in nested tables
          setPage(page - 1); // deleted item was the last in current page, so we move back one page
        }
        return {
          ...query,
          items: newItemsArray,
          totalItems: query.totalItems - 1
        };
      });
    }
  };
};
